import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export class getTicketsDataUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getTicketsData(req);
    }
}
